import {
	COLOR_BASE_GREY_10,
	COLOR_BASE_GREY_20,
	COLOR_BASE_GREY_70,
	COLOR_BASE_GREY_90,
	COLOR_UI_ERROR_LIGHT,
} from '@audi/audi-ui-design-tokens';
import styled from 'styled-components';

export const StyledLocationDialog = styled.div`
	align-self: center;

	.search__container {
		position: relative;
		margin-top: 1rem;
		display: flex;
		flex-direction: column;
		gap: 1em;
		z-index: 2;
		position: relative;
		background: white;
		padding: 1rem;

		.location__error {
			color: ${COLOR_UI_ERROR_LIGHT};
		}
	}

	.suggestions__container {
		background: white;
		position: absolute;
		font-family: AudiType, sans-serif;
		left: 0;
		right: 0;
		top: 3.6rem;
		z-index: 1;
		padding: 1rem;
		color: ${COLOR_BASE_GREY_70};
		box-shadow:
			0 10px 15px -3px rgb(0 0 0 / 0.1),
			0 4px 6px -4px rgb(0 0 0 / 0.1);

		li {
			padding: 0.3rem;
			cursor: default;
			&:hover {
				background: ${COLOR_BASE_GREY_10};
				color: ${COLOR_BASE_GREY_90};
			}
		}
	}

	.background__image {
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 50%;
		background-image: #808080;
		background-image: url('https://d1p8elq7q5x0x6.cloudfront.net/ngc/ngc-images/stock-car-match-map-ca.jpg');
		background-repeat: no-repeat;
		background-size: cover;
		z-index: -1;
	}

	.bottom__part {
		margin-top: 6rem;

		button {
			margin-top: 1rem;
		}

		button:disabled {
			background: ${COLOR_BASE_GREY_20};
			cursor: not-allowed;
			border: none;
		}
	}
`;
